import React from 'react';
import { CheckIcon } from 'lucide-react';
interface PackagesProps {
  openCalendly: () => void;
}
export const Packages = ({
  openCalendly
}: PackagesProps) => {
  const flexiblePackage = {
    name: 'Growth Partnership',
    description: 'Flexible, results-based marketing support aligned with your growth goals.',
    features: ['Pay based on agreed performance metrics', 'Flexible scope of services', 'Weekly strategy adjustments', 'No long-term commitment', 'Transparent reporting', 'Direct access to me ']
  };
  const retainerPackages = [{
    name: 'Essential Growth',
    period: 'Structured Retainer Package',
    description: 'Core marketing support with guaranteed results.',
    features: ['2 key service areas', 'Monthly strategy sessions', 'Performance guarantee', '30-day notice period', 'Monthly detailed reporting', 'Email & call support'],
    highlight: false
  }, {
    name: 'Advanced Growth',
    period: 'Structured Retainer Package',
    description: 'Comprehensive marketing partnership for serious growth.',
    features: ['All 4 service areas', 'Bi-weekly strategy sessions', 'Enhanced performance guarantee', 'Priority support response', 'Weekly progress updates', 'Dedicated Slack channel'],
    highlight: true
  }];
  return <section id="packages" className="w-full py-20 px-6 md:px-12 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Partnership Options
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Choose between flexible growth-based arrangements or structured
            retainer packages. Let's discuss the right solution for your needs.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-1/3 bg-white rounded-lg border border-gray-200 p-8 hover:shadow-md transition-shadow">
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-2">
                {flexiblePackage.name}
              </h3>
              <p className="text-indigo-600 font-medium mb-4">
                Performance-Based Partnership
              </p>
              <p className="text-gray-600">{flexiblePackage.description}</p>
            </div>
            <ul className="mb-8 space-y-3">
              {flexiblePackage.features.map((feature, index) => <li key={index} className="flex items-start">
                  <CheckIcon size={20} className="text-indigo-600 mr-2 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">{feature}</span>
                </li>)}
            </ul>
            <a href="#contact" className="block w-full border border-indigo-600 text-indigo-600 text-center py-3 rounded-md font-medium hover:bg-indigo-50 transition-colors">
              Discuss Options
            </a>
          </div>
          {retainerPackages.map((pkg, index) => <div key={index} className={`lg:w-1/3 rounded-lg p-8 hover:shadow-md transition-shadow ${pkg.highlight ? 'bg-indigo-600 text-white border-2 border-indigo-600 relative' : 'bg-white border border-gray-200'}`}>
              {pkg.highlight && <div className="absolute top-0 right-0 bg-yellow-400 text-gray-800 text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg">
                  MOST POPULAR
                </div>}
              <div className="mb-8">
                <h3 className={`text-2xl font-bold mb-2 ${pkg.highlight ? 'text-white' : 'text-gray-800'}`}>
                  {pkg.name}
                </h3>
                <div className="mb-4">
                  <span className={pkg.highlight ? 'text-indigo-100 font-bold' : 'text-indigo-600 font-bold'}>
                    {pkg.period}
                  </span>
                </div>
                <p className={pkg.highlight ? 'text-indigo-100' : 'text-gray-600'}>
                  {pkg.description}
                </p>
              </div>
              <ul className="mb-8 space-y-3">
                {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start">
                    <CheckIcon size={20} className={`mr-2 mt-0.5 flex-shrink-0 ${pkg.highlight ? 'text-indigo-200' : 'text-indigo-600'}`} />
                    <span className={pkg.highlight ? 'text-indigo-100' : 'text-gray-700'}>
                      {feature}
                    </span>
                  </li>)}
              </ul>
              <a href="#contact" className={`block w-full text-center py-3 rounded-md font-medium transition-colors ${pkg.highlight ? 'bg-white text-indigo-600 hover:bg-indigo-50' : 'bg-indigo-600 text-white hover:bg-indigo-700'}`}>
                Get Started
              </a>
            </div>)}
        </div>
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Ready to discuss pricing and find the perfect package for your
            needs? Let's have a conversation about your goals.
          </p>
          <button onClick={openCalendly} className="inline-block bg-indigo-600 text-white px-8 py-3 rounded-md font-medium hover:bg-indigo-700 transition-colors">
            Schedule a Free Consultation
          </button>
        </div>
      </div>
    </section>;
};